import React from "react";
import { Timeline, Box } from "fw/components";
import { ContentHeader, ContentBody } from 'areas/shared/components';
import * as API from 'modules/app/API';

class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.initialState();
  }

  initialState() {
    return {
      list: [],
      loading: false
    };
  }

  componentDidMount() {
    this.setState({
      loading: true
    });

    API.App.get('/query/getUserTimeline', null, {
      success: (r) => {
        let list = r.data.dateList.map((il, key) => {
          let items = il.items.map((n) => {
            let description = <p dangerouslySetInnerHTML={{ __html: n.content }}></p>;

            return {
              //time: n.time,
              icon: n.icon,
              text: n.text,
              description: description,
            };
          });

          return {
            date: il.date,
            items: items
          }
        });


        this.setState({
          loading: false,
          list: list
        });
      }
    });
  }

  render() {
    let content;

    if (this.state.loading)
      content = <p>Loading...</p>;
    else
      content = <Timeline list={this.state.list} />;

    return (
      <React.Fragment>
        <ContentHeader title="Notifications" description="Timeline">
        </ContentHeader>
        <ContentBody>
          <Box>
            {content}
          </Box>
        </ContentBody>
      </React.Fragment>
    );
  }
}

export default Notifications;



// WEBPACK FOOTER //
// ./src/areas/main/notifications/Notifications.js